import eventTypes from "@/events/event-types";
var AppHeader = /** @class */ (function () {
    function AppHeader(el) {
        console.log("[create] AppHeader");
        this._el = el;
    }
    AppHeader.prototype.setup = function () {
        this._langLinkElem = this._el.querySelector(".app-header__lang-link");
        this._menuLinkLang = this._el.querySelector(".app-menu__item:last-child > .app-menu__link");
        this._setNativeEvents();
    };
    AppHeader.prototype.teardown = function () {
        this._clearNativeEvents();
        delete this._el;
    };
    AppHeader.prototype._setNativeEvents = function () {
        var _this = this;
        this._onClickAtLangLink = function (e) {
            e.preventDefault();
            _this._switchLang();
        };
        this._langLinkElem.addEventListener(eventTypes.CLICK, this._onClickAtLangLink);
        this._menuLinkLang.addEventListener(eventTypes.CLICK, this._onClickAtLangLink);
    };
    AppHeader.prototype._clearNativeEvents = function () {
        this._langLinkElem.removeEventListener(eventTypes.CLICK, this._onClickAtLangLink);
    };
    AppHeader.prototype._switchLang = function () {
        if (!document.location) {
            return;
        }
        if (this._isJa()) {
            document.location.href = document.location.href.replace("japanese", "english");
        }
        else {
            document.location.href = document.location.href.replace("english", "japanese");
        }
    };
    AppHeader.prototype._isJa = function () {
        if (!document.location) {
            return false;
        }
        return document.location.href.includes("japanese");
    };
    return AppHeader;
}());
export default AppHeader;
